import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { History, X, Play } from "lucide-react";

/**
 * Inline banner shown at the top of a wizard form when a saved draft is detected.
 * Calls onResume() to restore form values, onDiscard() to delete the draft.
 */
export default function DraftBanner({ savedAt, onResume, onDiscard, label = "draft", step }) {
  if (!savedAt) return null;
  const when = new Date(savedAt);
  const ago = humanAgo(when);
  return (
    <Card className="p-3 border-accent/40 bg-accent/8 flex items-start md:items-center justify-between gap-3 flex-wrap" data-testid="draft-banner">
      <div className="flex items-start gap-3">
        <History className="h-4 w-4 text-accent mt-0.5 flex-shrink-0" />
        <div className="text-xs">
          <span className="font-medium text-sm">Resume your unsaved {label}?</span>
          <div className="text-muted-foreground mt-0.5">
            Last edited {ago} ({when.toLocaleString()})
            {typeof step === "number" && <Badge variant="outline" className="text-[10px] ml-2">Step {step + 1}</Badge>}
          </div>
        </div>
      </div>
      <div className="flex gap-2">
        <Button size="sm" onClick={onResume} data-testid="draft-resume-button"><Play className="h-3.5 w-3.5 mr-1" />Resume</Button>
        <Button size="sm" variant="ghost" onClick={onDiscard} data-testid="draft-discard-button"><X className="h-3.5 w-3.5 mr-1" />Discard</Button>
      </div>
    </Card>
  );
}

function humanAgo(d) {
  const diffMs = Date.now() - d.getTime();
  const sec = Math.round(diffMs / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.round(min / 60);
  if (hr < 48) return `${hr} hr ago`;
  return `${Math.round(hr / 24)} d ago`;
}
